import React, { ReactNode } from 'react'
import { MdChevronRight, MdOutlineAccountBalanceWallet, MdOutlineCheckCircle } from 'react-icons/md'

type TAutoWithdrawalLabel = {
  readonly isWithdrawalEnabled?: boolean
  readonly onClick: () => void
}
type TLabelData = {
  readonly enabled: TLabelDetails
  readonly disabled: TLabelDetails
}

type TLabelDetails = {
  readonly icon: ReactNode
  readonly title: string
  readonly description: string
}

export default function AutoWithdrawalLabel({
  isWithdrawalEnabled = false,
  onClick,
}: TAutoWithdrawalLabel) {
  const labelData: TLabelData = {
    disabled: {
      icon: <MdOutlineAccountBalanceWallet className='h-5 w-5 text-pop-grey-800' />,
      title: 'Enable Auto Withdrawal?',
      description:
        'Now your earnings go straight to your GoPay account automatically. Click here to set it up!',
    },
    enabled: {
      icon: <MdOutlineCheckCircle className='h-5 w-5 text-pop-grey-800' />,
      title: 'Auto Withdrawal Enabled.',
      description: 'Click here to manage auto withdrawal settings.',
    },
  }

  const labelDetails = isWithdrawalEnabled ? labelData.enabled : labelData.disabled

  return (
    <button
      className={`flex cursor-pointer flex-row items-center gap-1 rounded-b-lg px-4 py-2 ${
        isWithdrawalEnabled ? 'bg-pop-succees-background' : 'bg-pop-orange-50'
      }`}
      data-testid='label-container'
      onClick={onClick}
    >
      <div className='flex flex-1 flex-col gap-1'>
        <div className='flex flex-row items-center gap-1'>
          {labelDetails?.icon}
          <p className='text-xs font-semibold text-pop-grey-800'>{labelDetails.title}</p>
        </div>
        <p className='text-left text-xs text-pop-grey-800'>{labelDetails.description}</p>
      </div>
      <MdChevronRight className='h-6 w-6 text-pop-grey-800' />
    </button>
  )
}
